import AuthorsList from '@components/Authors/AuthorsList/AuthorsList'
import React, {createContext, FC} from 'react'
import PageContainer from '@components/UI/PageContainer/PageContainer'

const TYPE_SLUG = 'stories'

export const StoriesType = createContext(TYPE_SLUG)

const AuthorsPage: FC = () => {
  return (
    <StoriesType.Provider value={TYPE_SLUG}>
      <PageContainer>
        <AuthorsList/>
      </PageContainer>
    </StoriesType.Provider>
  )
}

export default AuthorsPage
